import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import StatusSearch from '~COMPONENTS/formInputs/StatusSearch';

export const OpenCartsSearch = ({ change, name, onSubmit, setSearchTerm, clearSearch }) => (
  <StatusSearch {...{ name, change, onSubmit, setSearchTerm, clearSearch }} />
);

OpenCartsSearch.defaultProps = {
  onSubmit: null
};

OpenCartsSearch.propTypes = {
  name: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  change: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  setSearchTerm: PropTypes.func.isRequired
};
export default reduxForm({
  form: 'openCartsSearch'
})(OpenCartsSearch);
